// ======================Key Feature Icons================================
import PeopleIcon from "../assets/homepage/svg/DedicatedTeams.svg";
import TruckIcon from "../assets/homepage/svg/MeasurementVehicle.svg";
import MoneyBagIcon from "../assets/homepage/svg/CompititiveBudget.svg";
import GlobIcon from "../assets/homepage/svg/GlobalPresence.svg";
// ======================Our Services Icons================================
import TowerIcon from "../assets/homepage/svg/TeleCommunication.svg";
import SystemsIcon from "../assets/homepage/svg/InformationSystems.svg";
import WebIcon from "../assets/homepage/svg/SoftwareDevelopment.svg";
import MedalIcon from "../assets/homepage/svg/QualityAssurance.svg";

export const carousalsContent = [
  { img: "null" },
  { img: "contactUsBanner" },
  { img: "AestheticStampBeautyMonogramLogo" },
];

export const keyFeatures = [
  {
    icon: PeopleIcon,
    title: "Specialized Teams",
    discription:
      "Our teams excel in fostering smooth communication and collaborative synergy. They ensure seamless integration of every project phase with customer goals, delivering consistently outstanding results.",
  },
  {
    icon: TruckIcon,
    title: "Measurement Vehicles",
    discription:
      "Our measurement vehicles offer a flexible and cost-effective solutions, eliminating the need for permanent fleet investments. They are engineered for precise, reliable performance, tailored to meet your project needs without long-term financial commitments.",
  },
  {
    icon: MoneyBagIcon,
    title: "Affordable Pricing",
    discription:
      "Our approach ensures a competitive budget, providing top-tier solutions without compromising quality. We meticulously optimize costs, delivering exceptional value and maximizing your investment while meeting your financial goals efficiently",
  },
  {
    icon: GlobIcon,
    title: " Global Reach",
    discription:
      "Our extensive global presence enables us to seamlessly serve customers around the world, leveraging local expertise and resources to deliver tailored solutions that meet diverse international requirements",
  },
];

export const ourServices = [
  {
    icon: TowerIcon,
    title: "Tele-Communication",
    discription:
      "As your dedicated outsourcing partner, our experts ensure top-tier mobile communication performance through comprehensive network testing and validation.",
  },
  {
    icon: SystemsIcon,
    title: "Infotainment Systems",
    discription:
      "Expertly testing infotainment systems, including HMI, SOS call systems, and Tuner & Media, for leading automotive brands to ensure seamless performance.",
  },

  {
    icon: MedalIcon,
    title: "Quality Assurance",
    discription:
      "Our Quality Assurance team upholds the highest standards through rigorous testing and advanced tools. We ensure every project meets industry benchmarks with precision.",
  },

  {
    icon: WebIcon,
    title: "Software Development",
    discription:
      "We deliver end-to-end software development solutions, prioritizing your business needs to create tailored, high-impact solutions.",
  },
];

export const questions = [
  {
    question: "What services does Vis Group offer?",
    answer: `VIS Group specializes in a comprehensive range of services
     including network benchmark testing, network field performance
      testing, infotainment system testing, quality assurance,
       software development, web application development, mobile
       application development, and a variety of testing services
        such as API testing, manual testing, automation testing,
         SOS emergency calls testing, and tuner and media testing.
         Our diverse service offerings allow us to cater to various
         industries and provide tailored solutions that meet specific
          business requirements.`,
  },
  {
    question: "Which industries do Vis Group serve?",
    answer: `We cater to a diverse range of industries including
     telecommunications, automotive, electronics,
      and software development. Our expertise
      in these sectors allows us to provide specialized
       solutions that address the unique challenges and
       requirements of each industry, helping our clients
       achieve their goals efficiently and effectively.`,
  },

  {
    question: " Do Vis Group offer customized solutions?",
    answer: `Yes, we offer fully customized solutions designed to meet
     the unique requirements of each client. Our team works
     closely with you to understand your challenges and deliver
      bespoke services that align with your business objectives.
       Whether you need specific testing services or a complete
        software development solution, we tailor our approach
        to fit your needs.`,
  },
  {
    question: "How is network benchmark testing performed?",
    answer: `We utilize advanced tools and methodologies to
     measure various network parameters such as latency, throughput,
      signal strength, and coverage. Our comprehensive testing
      process includes data collection from  network
       providers, thorough analysis of the data to identify
        performance trends and issues, and detailed reporting
         with actionable insights and recommendations.
         This approach ensures that our clients have a clear
          understanding of their network's performance
           and can make informed decisions.`,
  },
  {
    question: "Is there a different contract for each project?",
    answer: `Each project at VIS Group operates under its own
     standard contract. This ensures that the specific
     requirements, timelines, deliverables, and other
      critical aspects of each project are clearly defined
       and agreed upon by both parties. This approach helps
        maintain transparency, accountability, and clarity
         throughout the project's lifecycle, ensuring that
          all parties are aligned and that the project meets
          the client's expectations.`,
  },

  {
    question:
      "Does VIS Group operate its own fleet of measurement vehicles and tools?",
    answer: `VIS Group operates its own fleet of measurement vehicles
     equipped with advanced tools and devices.
     These vehicles are used to collect network data for
     various tasks, including network benchmark testing,
     field performance testing, roaming tests, and user acceptance testing. 
      By managing our own fleet, we ensure the accuracy and reliability of the data
      collected, allowing us to provide precise and actionable insights to our clients.`,
  },
  {
    question: "Does VIS Group have any management or ISO certifications?",
    answer: `VIS Group's procedures are certified to meet high 
    standards of quality and management. We hold several key
     certifications, including ISO 9001 for quality management
      systems, ISO 45001 for occupational health and safety
       management systems, ISO 27001 for information security
        management, and ISO/IEC 20000 for IT service management.
         These certifications demonstrate our commitment to
         maintaining excellence, safety, and security in all
         our operations.`,
  },

  {
    question: "Where is VIS Group located?",
    answer: `VIS Group is headquartered in Germany and operates
     additional offices strategically located in the Gulf, Asia,
     and Europe. This global presence enables us to provide
     localized support and services to clients around the world.
      ensuring that we can meet the specific needs of different
       regions and Clients.`,
  },

  {
    question: "How can I contact VIS Group for more information or a quote?",
    answer: `You can contact VIS Group through our website's contact 
    form, via email at info@vis-group.eu, or by calling
    our partner offices. Our contact details are available on the
    Contact Us page of our website. We are committed to
     providing prompt and comprehensive
      responses to all inquiries.`,
  },
];
